import React from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { GoToButton } from '@homeviews/analytics'
import type { Recommendation } from '@homeviews/analytics'

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '100%',
      marginBottom: '16px',
      padding: '15px 20px',
      backgroundColor: '#b2ecdf',
      borderRadius: '8px',
    },
    title: {
      fontSize: '14px',
      fontWeight: 700,
      marginBottom: '12px',
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '10px',
    },
    checkMarkAndDescriptionWrapper: {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    checkMarkWrapper: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: '25px',
      height: '25px',
      marginRight: '8px',
      borderStyle: 'solid',
      borderRadius: '12.5px',
      backgroundColor: '#000433',
    },
    checkMarkImg: {
      width: '11px',
    },
    description: {
      fontSize: '14px',
      fontWeight: 700,
    },
  }),
)

type RecommendationsProps = {
  data: Array<Recommendation> | false
  goToTrackingEventName: string
}

export const Recommendations: FC<RecommendationsProps> = ({
  data,
  goToTrackingEventName,
}) => {
  const classes = useStyles()

  if (!data || data.length === 0) return null

  return (
    <div className={classes.wrapper}>
      <p className={classes.title}>Recommendations</p>
      <div>
        {data.map(({ description, goToHref, goToDisabled }) => (
          <div key={goToHref} className={classes.row}>
            <div className={classes.checkMarkAndDescriptionWrapper}>
              <div className={classes.checkMarkWrapper}>
                <img
                  className={classes.checkMarkImg}
                  src="assets/icons/small/check.svg"
                  alt="Check Mark"
                />
              </div>
              <div className={classes.description}>{description}</div>
            </div>
            <GoToButton
              href={goToHref}
              trackingEventName={goToTrackingEventName}
              isDisabled={goToDisabled}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
